import React from 'react';
import { withRouter } from 'react-router';

import SideBarNavigationLink from '../layout/SideBarNavigationLink';

import { Icon } from '../icons';

const List = ({ event, match }) => {
  if(!event.schedules || event.schedules.length === 0) {
    return <p>No schedules</p>;
  }

  return (
    <ul className="profile-list">
      {event.schedules.map(schedule =>
        <SideBarNavigationLink key={schedule.id} to={`/organisations/${event.organisation_id}/events/${event.id}/schedules/${schedule.id}`} active={match.params.scheduleId === schedule.id}>
          <Icon type='profile' className="profile-icon"/>
          <div className="profile-name">
            {schedule.description}
          </div>
        </SideBarNavigationLink>
      )}
    </ul>
  )
}

export default withRouter(List);



// WEBPACK FOOTER //
// ./src/components/schedules/List.js